import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-features',
  templateUrl: './hometwo-features.component.html',
  styleUrls: ['./hometwo-features.component.scss']
})
export class HometwoFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
